export default __webpack_public_path__ + "static/media/person-group-black-icon.61cd1996.svg";